import { ResetStateAction } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";
import { GetResponseInterface } from "interfaces/ActionReducer/GetMethod/GetResponse";

export const GET_PROJECTS = "GET_PROJECTS";
export const PROJECTS_RECEIVED = "PROJECTS_RECEIVED";
export const PROJECT_SELECTED = "PROJECT_SELECTED";
export const POST_NEW_PROJECT = "POST_NEW_PROJECT";
export const UPDATE_PROJECT = "UPDATE_PROJECT";
export const DELETE_PROJECT = "DELETE_PROJECT";
export const GET_PROJECT_STATUSES = "GET_PROJECT_STATUSES";
export const STATUSES_RECEIVED = "STATUSES_RECEIVED";
export const NEW_PROJECT_CREATED = "NEW_PROJECT_CREATED";
export const CLEAR_SELECTED_PROJECT = "CLEAR_SELECTED_PROJECT";
export const SHOW_PROJECTS_LIST_VIEW = "SHOW_PROJECTS_LIST_VIEW";
export const ADD_COMMENT_TO_PROJECT = "ADD_COMMENT_TO_PROJECT";

export interface GetProjectsAction {
    type: typeof GET_PROJECTS;
}

export interface PostNewProjectPayload {
    name: string;
    description: string;
    status_id: number;
    file?: File | null;
    file_name?: string;
}

export interface UpdateProjectPayload {
    name?: string;
    description?: string;
    status_id?: number;
    file?: File | null;
    file_name?: string;
}

export interface ProjectsReceivedAction {
    type: typeof PROJECTS_RECEIVED;
    payload: { data: GetResponseInterface };
}

export interface ProjectSelectedAction {
    type: typeof PROJECT_SELECTED;
    payload: { data: { [prop: string]: any } };
}

export interface PostNewProjectAction {
    type: typeof POST_NEW_PROJECT;
    payload: { afterProcess?: () => void; params: PostNewProjectPayload };
}

export interface UpdateProjectAction {
    type: typeof UPDATE_PROJECT;
    payload: {
        params: UpdateProjectPayload;
        project_id: number;
        afterProcess?: () => void;
    };
}

export interface DeleteProjectAction {
    type: typeof DELETE_PROJECT;
    payload: { project_id: number; afterProcess?: () => void };
}

export interface GetProjectStatusesAction {
    type: typeof GET_PROJECT_STATUSES;
}

export interface StatusesReceivedAction {
    type: typeof STATUSES_RECEIVED;
    payload: { data: GetResponseInterface };
}
export interface ProjectCreatedAction {
    type: typeof NEW_PROJECT_CREATED;
    payload: { isProjectCreated: boolean };
}

export interface ShowProjectsListViewAction {
    type: typeof SHOW_PROJECTS_LIST_VIEW;
    payload: { showProjectsListView: boolean };
}

export interface AddCommentToProjectParamsTypes {
    comment: string;
    parent_comment_id?: number | string;
    project_id: string | number;
}

export interface AddCommentToProjectAction {
    payload: { params: AddCommentToProjectParamsTypes };
    type: typeof ADD_COMMENT_TO_PROJECT;
}

export interface ProjectsStateInterface {
    projects: GetResponseInterface;
    selectedProject: { [prop: string]: any };
    isProjectsReceived: boolean;
    statusesReceived: GetResponseInterface;
    newProjectCreated?: boolean;
    showProjectsListView?: boolean;
}

export type ProjectsActionsType =
    | GetProjectsAction
    | ProjectsReceivedAction
    | ProjectSelectedAction
    | PostNewProjectAction
    | UpdateProjectAction
    | DeleteProjectAction
    | GetProjectStatusesAction
    | ProjectCreatedAction
    | ShowProjectsListViewAction
    | AddCommentToProjectAction;
